import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ExcCoreModule} from 'exc-core-v2';

@Component({
  selector: 'app-exg-object-list',
  templateUrl: './exg-object-list.component.html',
  styles: [
  ]
})
export class ExgObjectListComponent implements OnInit {

  @Input() formIdent = 'formID';
  @Input() submitText = 'Abschließen';
  @Input() objectMeta = {
    Headers: [],
    Types: [],
    Template: [],
    Required: [],
    MinRow: 1,
    MaxRow: -1
  };
  @Input() values: any;
  objValues: any;

  _forceDisable = false;
  get forceDisable(): boolean {
    return this._forceDisable;
  }
  @Input() set forceDisable(value: boolean) {
    this._forceDisable = value;
    if (!this.isViewInit) {
      setTimeout(() => {
        this.cleanUpValues();
      }, 50);
    }
  }
  isLoading = true;
  isViewInit = true;

  @Output() formSubmit = new EventEmitter<any>();

  currentRowCount = 1;

  ngOnInit(): void {
    this.isViewInit = false;
    if (this.values) {
      this.objValues = JSON.parse(this.values);
    }
    this.initValues();
    this.isLoading = false;
  }

  initValues(): void {
    if (!this.objValues) {
      this.objValues = [];
    }
    if (this.objectMeta.Template && this.objValues.length === 0) {
      if (this.objectMeta.MinRow && this.objectMeta.MinRow > 1) {
        for (let i = 1; i <= this.objectMeta.MinRow ; i++) {
          ExcCoreModule.Array.Add(this.objValues, this.constructNewTemplateRow());
        }
        this.currentRowCount = this.objectMeta.MinRow;
      } else {
        ExcCoreModule.Array.Add(this.objValues, this.constructNewTemplateRow());
      }
    } else {
      this.currentRowCount = this.objValues.length;
      /*
      if (this.objectMeta.MinRow && this.objectMeta.MinRow > 1) {
        for (let i = 1; i <= this.objectMeta.MinRow; i++) {
          // ExcCoreModule.Array.Add(this.values, this.constructNewValueRow());
        }
        this.currentRowCount = this.objectMeta.MinRow;
      } else {
        ExcCoreModule.Array.Add(this.values, this.constructNewValueRow());
      }*/
    }
  }

  onInputChange(event: any, rowIndex: number, colIndex: number): void {
    if (this.objectMeta.Types[colIndex] === 'checkbox') {
      event.value = !this.isValidBoolean(event.value);
    }
    this.objValues[rowIndex][this.objectMeta.Headers[colIndex]] = event.value;
  }

  submitForm(event: { preventDefault: () => void; stopPropagation: () => void; }): void{
    event.preventDefault();
    event.stopPropagation();
    this.formSubmit.emit(this.objValues);
  }

  cleanUpValues(): void {
      const elements = document.forms[this.formIdent as any].getElementsByTagName('input');
      for (const element of elements) {
        element.disabled = this.forceDisable;
      }
  }

  constructNewValueRow(): object {
    const valueRowObj = {};
    let index = 0;
    for (const type of this.objectMeta.Types) {
      let singleValue: any;
      if (['text', 'date'].includes(type)) {
        singleValue = '';
      } else if (type === 'number') {
        singleValue = 0;
      } else if (type === 'checkbox') {
        singleValue = false;
      } else {
        singleValue = null;
      }
      // @ts-ignore
      valueRowObj[this.objectMeta.Headers[index]] = singleValue;
      index++;
    }
    return valueRowObj;
  }

  constructNewTemplateRow(): object {
    const valueRowObj = {};
    let index = 0;
    for (const temp of this.objectMeta.Template) {
      valueRowObj[this.objectMeta.Headers[index]] = temp;
      index++;
    }
    return valueRowObj;
  }

  addValueRow(): void {
    if (this.isValidToAdd()) {
      this.currentRowCount++;
      ExcCoreModule.Array.Add(this.objValues, this.constructNewValueRow());
    }
  }

  removeValueRow(index: number): void {
    if (this.isValidToRemove()) {
      this.currentRowCount--;
      ExcCoreModule.Array.Remove(this.objValues, this.objValues[index]);
    }
  }

  isValidToAdd(): boolean {
    return (this.currentRowCount < this.objectMeta.MaxRow || this.objectMeta.MaxRow === -1) && !this.forceDisable;
  }
  isValidToRemove(): boolean {
    return (this.currentRowCount > this.objectMeta.MinRow || this.objectMeta.MinRow === -1) && this.currentRowCount > 1
      && !this.forceDisable;
  }
  isValidBoolean(value: any): boolean {
    switch (value) {
      case true:
      case 'true':
        return true;
      default:
        return false;
    }
  }

}
